import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        sokoPrimary: "#F55E15",
        sokoDeep: "#FF5722",
        sokoBlack: "#000000",
        sokoGrey: "#616161",
        error: "#F55E15",
        footer: "#2e1d04",
      },
    },
  },
});
